import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefaultAvatar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<circle cx={64} cy={64} r={64} fill="currentColor" /><path fillOpacity={0.2} d="M107.3 111a63.3 63.3 0 0 1-86 .5A72.1 72.1 0 0 1 52 96l1.7-6.9c-4.5-4.5-8.9-12-9.6-17.9-5.2-1.8-7.3-12.2-3.9-16.8-1.9-29 12.2-32 24-32.2 15.2-.2 27.3 6.2 24 32 4.4 3.9 2.5 15.2-2.9 15.4a37 37 0 0 1-9.6 19.6l1 6.2c8.8 2.7 20 7.8 30.5 15.5z" /></svg>;
export default SvgDefaultAvatar;